document.addEventListener("latte:init", init);
function init() {

	$('.score--tab--box[data-box="0"]').addClass('show-box');

	$('.score--tab').click(function (e) {
		$(this).closest('.score').find('.score--tab--box').removeClass('show-box');
		$(this).closest('.score').find('.score--tab').removeClass('active');
		$(this).addClass('active');
		tabId = $(this).attr('data-tabId');
		$(this).closest('.score').find('.score--tab--box[data-box="' + tabId + '"]').addClass('show-box');
	});

	$('.score--tabs--mobile').find('select').change(function (e) {
		$(this).closest('.score').find('.score--tab--box').removeClass('show-box');
		$(this).closest('.score').find('.score--tab').removeClass('active');
		tabId = $(this).val();
		$(this).closest('.score').find('.score--tab--box[data-box="' + tabId + '"]').addClass('show-box');
	});

}


//////////////////
// WEBPACK FOOTER
// ./public/js/score.js
// module id = 88
// module chunks = 0